
import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { FormBase, FormInput, FormVat, FormPhone, FormSelect, FormMultiSelect, FormTextarea, FormFile, FormError, FormSubmit } from "./parts";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { extend } from "vee-validate";

extend("belgium_vat", {
    validate(value: any) {
        value = value.replace(/\./g, "").replace(/-/g, "");

        if (!/^\d{10}$/.test(value)) {
            return "Dit is geen geldig ondernemingsnummer.";
        }

        const numbers = value.slice(0, 8);
        const checksum = parseInt(value.slice(8, 10), 10);

        return 97 - (parseInt(numbers, 10) % 97) === checksum || "Dit is geen geldig ondernemingsnummer.";
    },
    message: "Dit is geen geldig ondernemingsnummer."
});

const phonePatterns = [
    /^\d{8,9}$/, // Belgium: 9 or 10 digits, starts with 0
    /^[1-9]\d{8}$/, // Netherlands: 10 digits, starts with 0 + non-zero digit
];

extend("phone_number", {
    validate(value: string) {
        if (!value) {
            return "Dit is geen geldig telefoonnummer.";
        }

        // Remove spaces, dots, and dashes
        value = value.replace(/[\s.-]/g, "");

        // Check if the number matches any of the country-specific patterns
        const isValid = phonePatterns.some(pattern => pattern.test(value));

        return isValid || "Dit is geen geldig telefoonnummer.";
    },
    message: "Dit is geen geldig telefoonnummer."
});

@Component({
    components: {
        FormBase,
        FormInput,
        FormVat,
        FormPhone,
        FormSelect,
        FormMultiSelect,
        FormTextarea,
        FormError,
        FormFile,
        FormSubmit
    }
})
export default class WpContactForm extends Vue {
    @Prop() form: any;

    @Ref() readonly component!: HTMLElement;

    height = 0;

    parsedFields: any = [];

    formId = "";

    payload: any = {};

    errorResponse: any = {
        status: 0,
        errors: []
    };

    success_message = "";

    mounted() {
        this.parseContactFormSeven();

        this.preparePayload();

        this.height = this.component.clientHeight;
    }

    parseContactFormSeven() {
        var formHTML = document.createElement("html");
        formHTML.innerHTML = this.form;

        this.formId = (formHTML.querySelector("input[name='_wpcf7']") as HTMLInputElement).value;

        // By default WP Contact Form 7 fields are wrapped in a label
        const fields: any = formHTML.querySelectorAll(".wpcf7-form-control");

        fields.forEach((f: any) => {
            // find parent label class
            const potentialLabel = f.parentNode.parentNode;
            let label = "";

            if (potentialLabel.nodeName === "LABEL") {
                label = potentialLabel.innerText.split("\n")[0];
            }

            let rules = [];
            if (f.classList.contains("wpcf7-validates-as-required")) {
                rules.push("required");
            }

            let formClass = "lg:col-span-2";
            if (f.classList.contains("span-1")) {
                formClass = "lg:col-span-1";
            }

            if (f.classList.contains("span-2")) {
                formClass = "lg:col-span-2";
            }

            let formInput = "";

            switch (f.nodeName) {
                case "INPUT":
                    formInput = "input";
                    break;
                case "SELECT":
                    formInput = "select";
                    break;
                case "TEXTAREA":
                    formInput = "textarea";
                    break;
                case "SPAN":
                    formInput = "multi-select";
                    break;
            }

            switch (f.type) {
                case "email":
                    rules.push("email");
                    break;
                case "tel":
                    formInput = "phone";
                    break;
                case "file":
                    formInput = "file";
                    formClass = "lg:col-span-2";
                    break;
            }

            if (f.classList.contains("vat")) {
                formInput = "vat";
            }

            let options: any = [];
            if (formInput === "select") {
                f.childNodes.forEach((option: any) => {
                    options.push(option.value);
                });
            }

            if (formInput === "multi-select") {
                f.childNodes.forEach((option: any) => {
                    options.push(option.innerText);
                });
            }

            let min = undefined;
            if (!isNaN(f.min) && f.min) {
                rules.push(`min:${f.min}`);
                min = Number(f.min);
            }

            let max = undefined;
            if (!isNaN(f.max) && f.min) {
                rules.push(`max:${f.max}`);
                max = Number(f.max);
            }

            if (["input", "textarea"].includes(formInput) && f.type !== "submit") {
                this.parsedFields.push({
                    placeholder: label,
                    type: f.type,
                    name: f.name,
                    min: min,
                    max: max,
                    formClass: formClass,
                    formInput: formInput,
                    rules: rules.join("|")
                });
            }

            if (["phone"].includes(formInput) && f.type !== "submit") {
                rules.push("phone_number");

                this.parsedFields.push({
                    placeholder: label,
                    type: f.type,
                    name: f.name,
                    formClass: formClass,
                    formInput: formInput,
                    rules: rules.join("|")
                });
            }
            if (["vat"].includes(formInput) && f.type !== "submit") {
                rules.push("belgium_vat");
                this.parsedFields.push({
                    placeholder: label,
                    type: f.type,
                    name: f.name,
                    formClass: formClass,
                    formInput: formInput,
                    rules: rules.join("|")
                });
            }

            if (["select"].includes(formInput) && f.type !== "submit") {
                this.parsedFields.push({
                    placeholder: label,
                    type: f.type,
                    name: f.name,
                    options: options,
                    formClass: formClass,
                    formInput: formInput,
                    rules: rules.join("|")
                });
            }

            if (["multi-select"].includes(formInput) && f.type !== "submit") {
                this.parsedFields.push({
                    label: label,
                    placeholder: label,
                    type: f.type,
                    name: f.firstChild.firstChild.firstChild.name.replace(/\[\]/g, ""),
                    options: options,
                    formClass: formClass,
                    formInput: formInput,
                    rules: rules.join("|")
                });
            }

            if (["file"].includes(formInput) && f.type !== "submit") {
                this.parsedFields.push({
                    placeholder: label,
                    type: f.type,
                    name: f.name,
                    options: options,
                    formClass: formClass,
                    formInput: formInput,
                    rules: rules.join("|")
                });
            }
        });
    }

    preparePayload() {
        this.parsedFields.forEach((field: any) => {
            if (field.type === "file") {
                this.payload[field.name] = [];
                return;
            }
            if (field.type === "multi-select") {
                this.payload[field.name] = [];
                return;
            }
            this.payload[field.name] = "";
        });
    }

    private submit(form: FormClass) {
        this.success_message = "";
        const formData = new FormData();
        formData.append("method", "_POST");
        formData.append("form_id", this.formId);

        Object.keys(this.payload).forEach((key: any) => {
            const value = this.payload[key];

            // find the field in the parsedFields
            const field = this.parsedFields.find((f: any) => f.name === key);
            if (field.type === "file") {
                Object.values(value).forEach((file: any) => {
                    formData.append(`${key}[]`, file);
                });
            } else {
                formData.append(key, value);
            }
        });

        // @ts-ignore
        axios
            .post(`/api/forms/wp-form`, formData)
            .then((response: any) => {
                // @ts-ignore
                if (window.hasOwnProperty("dataLayer") && dataLayer) {
                    console.log(this.payload);

                    // @ts-ignore
                    dataLayer.push({
                        event: "formSubmission",
                        formId: this.formId,
                        response: [
                            ...Object.keys(this.payload).map((key: any) => {
                                let value = this.payload[key];

                                const field = this.parsedFields.find((f: any) => f.name === key);
                                if (field.type !== "file") {
                                    return { name: key, value: value };
                                }
                            }),
                            { name: "href", value: window.location.href },
                            { name: "pathname", value: window.location.pathname }
                        ],
                        "gtm.uniqueEventId": 922
                    });
                }

                this.preparePayload();

                this.success_message = response.data.data.message;
            })
            .catch((e: any) => {
                if (e.response && e.response.data && e.response.data.data && e.response.data.data.message) {
                    this.errorResponse = {
                        status: 422,
                        errors: [[e.response.data.data.message]]
                    };
                } else {
                    console.error(e);
                }
            })
            .finally(() => {
                form.reset();
            });
    }
}
